import React, { useEffect, useState } from "react";

//service
import { getPaginatedPromoCodes } from "../graphql/services";

//mui
import { Tooltip } from "@mui/material";

//hook
import useTranslation from "../hooks/useTranslation";

//next
import { useRouter } from "next/router";
import Image from "next/image";

// js
import dayjs from "dayjs";

// Component
import Spinner from "../components/Spiner";
import Pagination from "../components/Pagination";

// Redux
import { useSelector } from "react-redux";

const CodePromoLayout = () => {
  const TOKEN = useSelector((state) => state?.auth?.access_token);
  const router = useRouter();
  const { redirect } = router.query;
  const { t } = useTranslation();

  //fetch PromoCode
  const [paginatedPromoCodes, setPaginatedPromoCodes] = useState();
  const [loading, setLoading] = useState();

  //comp pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  // get all promo code with pagination
  const getPaginatePromoCode = async (skip) => {
    setLoading(true);
    const { data, error } = await getPaginatedPromoCodes({
      options: {
        take: pageSize,
        skip: Number(skip) ? Number(skip) * pageSize : 0,
        where: {
          code: null,
        },
      },
      TOKEN,
    });
    if (error) {
      console.log("error", error);
      setLoading(false);
    } else {
      setPaginatedPromoCodes(data?.paginatedPromoCodes);
      setLoading(false);
    }
  };
  useEffect(() => {
    getPaginatePromoCode(currentPage);
  }, [currentPage]);

  //Copy PromoCode function
  const [title, setTitle] = useState("Copy");
  const handleCopy = (code) => {
    const textToCopy = code;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log(t("Texte copié avec succès"));
      })
      .catch((error) => {
        console.error("Error copying text:", error);
      });
    setTitle("Copied");
    setTimeout(() => {
      setTitle("Copy");
    }, 400);
    // router.push(`${redirect ? redirect : "/codePromo"}`);
  };

  const endCodeDate = dayjs().subtract(1, "day").endOf("day").toISOString();

  return (
    <div className="max-w-[1366px] min-h-[100vh] mx-auto pt-[109px] px-[30px]">
      <div className="flex flex-col w-full gap-16 mt-20">
        <h2 className="text-3xl font-bold font-MyriadPro uppercase tracking-widest">
          {t("fidarri coupons")}
        </h2>
        <div className="flex flex-col gap-4 mb-24">
          {loading !== null && loading ? (
            <div className="hidden sm:flex w-full h-full items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <>
              {paginatedPromoCodes && paginatedPromoCodes?.totalCount === 0 ? (
                <div className="flex flex-col">
                  <p className="md:text-lg md:font-semibold lg:text-2xl lg:font-semibold font-MyriadPro">
                    {t(
                      "Chez Fidarri, nous nous engageons à offrir à nos clients les meilleures offres et réductions. Restez à l'écoute pour des promotions incroyables à venir bientôt!"
                    )}
                  </p>
                  <Image
                    width={500}
                    height={500}
                    src="/svg/coponEmp.svg"
                    alt="coupon"
                    className="mx-auto"
                  />
                </div>
              ) : (
                paginatedPromoCodes?.nodes?.map((code, index) => (
                  <div
                    key={index}
                    className="hidden sm:flex shadow-lg bg-opacity-10 w-full h-[294px] rounded-lg bg-white lg:flex-row items-center"
                  >
                    <div className="h-full flex items-center justify-center mx-8">
                      <img
                        src="/images/copon.png"
                        alt="copone"
                        className="w-[100%] h-[150px] rounded-lg"
                      />
                    </div>
                    <div className="flex-auto flex flex-col gap-4">
                      <p className="font-bold text-2xl text-[#D76262]">
                        {t("code coupon")}
                      </p>
                      <p className="text-2xl md:text-[32px] font-bold">
                        {code.discountPercentage
                          ? code.discountPercentage + " %"
                          : code.discount + " DZD"}{" "}
                        {t("de réduction avec les coupons fiddari")}
                      </p>
                      <span className="md:text-lg text-base text-[#888888]">
                        {t("Ce code de réduction expire après")}{" "}
                        {code.usageLimit - code.usedTimes}{" "}
                        {t("utilisations, plus vite avant la fin de l’offre!")}
                      </span>
                    </div>
                    <div className="px-10 flex flex-col items-center">
                      <Tooltip title={title} arrow followCursor placement="top">
                        <div
                          onClick={() => handleCopy(code.code)}
                          className="relative cursor-pointer"
                        >
                          <img src="/svg/coponCut.svg" alt="cut" />
                          <p className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-10 text-sm md:text-[18px] w-full text-center font-MyriadPro font-bold text-secondary">
                            {code.code}
                          </p>
                        </div>
                      </Tooltip>
                      <p className="text-sm font-semibold">
                        {code.usedTimes} {t("utilisé")}
                      </p>
                    </div>
                  </div>
                ))
              )}
            </>
          )}

          {loading !== null && loading ? (
            <div className="sm:hidden w-full h-full flex items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <>
              {paginatedPromoCodes &&
                paginatedPromoCodes?.totalCount > 0 &&
                paginatedPromoCodes?.nodes?.map((code, index) => (
                  <div
                    key={index}
                    className="sm:hidden flex shadow-lg bg-opacity-10 w-full h-fit py-3 rounded-lg bg-white flex-col gap-7  md:flex-row items-center p-2"
                  >
                    <div className="h-full  sm:flex items-center justify-center mr-4 ml-3">
                      <img
                        src="/images/copon.png"
                        alt="copone"
                        className="w-[100%] h-[150px] rounded-lg"
                      />
                    </div>
                    <div className="flex-auto">
                      <div className="flex items-center justify-evenly w-full">
                        <p className="font-bold text-16 text-[#D76262]">
                          {t("code coupon")}
                        </p>
                        <div className=" flex flex-row items-center">
                          <div
                            onClick={() => handleCopy(code.code)}
                            className="relative cursor-pointer"
                          >
                            <img
                              src="/svg/coponCut.svg"
                              alt="cut"
                              width={70}
                              height={40}
                            />
                            <p
                              id="code"
                              className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-10 text-[14px] font-MyriadPro font-bold text-secondary"
                            >
                              {code.code}
                            </p>
                          </div>
                          <p className="text-xs font-semibold">
                            {code.usedTimes} {t("utilisé")}
                          </p>
                        </div>
                      </div>

                      <p className="text-[16px] font-bold">
                        {code.discountPercentage
                          ? code.discountPercentage + " %"
                          : code.discount + " DZD"}{" "}
                        {t("de réduction avec les coupons fiddari")}
                      </p>
                      <span className="text-xs text-[#888888]">
                        {t("Ce code de réduction expire après")}{" "}
                        {code.usageLimit - code.usedTimes}{" "}
                        {t("utilisations, plus vite avant la fin de l’offre!")}
                      </span>
                    </div>
                  </div>
                ))}
            </>
          )}
          {paginatedPromoCodes?.totalCount > 0 ? (
            <div className="w-full flex justify-end mt-6">
              <Pagination
                count={paginatedPromoCodes?.totalCount}
                pagesize={pageSize}
                setPage={(e) => {
                  setCurrentPage(e);
                }}
                page={Number(currentPage) ? Number(currentPage) : 0}
                showPages={3}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CodePromoLayout;
